var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-horizontal-panel',{staticStyle:{"overflow":"hidden"}},[_c('deviationSearchFilters',{attrs:{"slot":"left"},slot:"left"}),_c('deviationList',{staticStyle:{"flex":"1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }